import Box from '~/common/components/Box';
import CalculationCard from '~/common/components/CalculationCard';
import type {
  CalculationResult,
  W2CalculationResult,
  WvoeCalculationResult,
} from '~/pages/IncomeCalculator/types';

type CalculationCardItem = CalculationResult &
  Partial<W2CalculationResult> &
  Partial<WvoeCalculationResult>;

type CalculationCardsProps = {
  calculations?: Array<CalculationCardItem>;
  selectedCard?: Pick<
    CalculationCardItem,
    'formulaName' | 'incomeCalculatorType' | 'scenarioId'
  >;
  onSelect: (card: CalculationCardItem) => void;
};

const CalculationCards = ({
  calculations,
  selectedCard,
  onSelect,
}: Readonly<CalculationCardsProps>) => {
  return (
    <Box
      p={0}
      pb={10}
      m={0}
      display="inline-flex"
      flexWrap="wrap"
      role="radiogroup"
      aria-labelledby="page-header-subtitle"
    >
      {calculations?.map((card, index) => {
        const {
          formulaName,
          calculationAmount,
          incomeCalculatorType,
          totalIncome,
          isDisabled,
        } = card;
        const cardLabel = formulaName ?? card.scenarioName ?? '';
        const isChecked =
          selectedCard === card ||
          (selectedCard?.scenarioId != null &&
            selectedCard.scenarioId === card.scenarioId) ||
          (selectedCard?.scenarioId == null &&
            formulaName != null &&
            selectedCard?.formulaName === formulaName &&
            selectedCard?.incomeCalculatorType === incomeCalculatorType);
        const props = { ...card, isChecked };
        const cardKey = [
          card.calculationId,
          card.scenarioId,
          formulaName ?? card.scenarioName,
          index,
        ].join('-');

        return (
          <Box key={cardKey} pr={3} onClick={() => onSelect(card)}>
            <CalculationCard
              title={incomeCalculatorType ?? card.scenarioName ?? 'Calculation'}
              payFrequency={cardLabel}
              isChecked={isChecked}
              isDisabled={isDisabled}
              amount={totalIncome || calculationAmount}
              {...props}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default CalculationCards;
